import { shouldSkipEntry } from './get-workout-exercises';
export function exerciseToTrainingLabel(workout) {
    const exerciseMap = {};
    let exerciseIndex = 0;
    workout.sections.forEach((section) => {
        // Build a map of exerciseId -> superset info
        const exerciseToSupersetInfo = new Map();
        // First pass: identify superset exercises
        let tempExerciseIndex = 0;
        section?.entries?.forEach((entry) => {
            if (entry.__type === 'WorkoutSuperset') {
                const setLetter = String.fromCharCode(65 + tempExerciseIndex);
                entry?.exercises?.forEach((exercise, supersetIndex) => {
                    exerciseToSupersetInfo.set(exercise.workoutExerciseId, {
                        letter: setLetter,
                        index: supersetIndex + 1,
                    });
                });
                tempExerciseIndex++;
            }
            else if (!(entry.__type === 'WorkoutAlternateGroup' &&
                // do not count overlapping alt groups; they won't consume a letter
                shouldSkipEntry(entry, section.entries))) {
                tempExerciseIndex++;
            }
        });
        // Second pass: label all entries
        section?.entries?.forEach((entry) => {
            const setLetter = String.fromCharCode(65 + exerciseIndex);
            if (entry.__type === 'WorkoutSuperset') {
                entry?.exercises?.forEach((exercise, supersetIndex) => {
                    exerciseMap[exercise.workoutExerciseId] = `${setLetter}${supersetIndex + 1}`;
                });
                exerciseIndex++;
            }
            else if (entry.__type === 'WorkoutAlternateGroup') {
                // Check if any exercise in this alternate group is part of a superset
                const overlappingExerciseId = entry.exercises.find((exercise) => exerciseToSupersetInfo.has(exercise.workoutExerciseId))?.workoutExerciseId;
                const supersetInfo = overlappingExerciseId
                    ? exerciseToSupersetInfo.get(overlappingExerciseId)
                    : undefined;
                if (supersetInfo) {
                    // This alternate group is part of a superset, use superset labeling
                    entry.exercises.forEach((exercise) => {
                        exerciseMap[exercise.workoutExerciseId] =
                            `${supersetInfo.letter}${supersetInfo.index}`;
                    });
                    // Don't increment exerciseIndex as this is handled by the superset
                }
                else {
                    // Regular alternate group, use single letter for all exercises
                    entry.exercises.forEach((exercise) => {
                        exerciseMap[exercise.workoutExerciseId] = setLetter;
                    });
                    exerciseIndex++;
                }
            }
            else {
                exerciseMap[entry.workoutExerciseId] = setLetter;
                exerciseIndex++;
            }
        });
    });
    return exerciseMap;
}
//# sourceMappingURL=exercise-group.js.map